import React from 'react';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const CardHeadline = (props) => {
  const { primaryHed, path, id } = props;
  const getCardIdInURL = path.split('/').reverse()[0] || false;

  // the following logic will check if the path given contains:
  // 1. a blog/ or live-blog/ on the url
  // 2. a cardId (which has ncrdXXXXXXX) on the url;
  const findBlogInURL = (/(blog\/|live-blog\/)/g).test(path);
  const findCardIdInURL = (/ncrd([0-9]{6,7})/g).test(path);
  const isCardIdSameAsIdInURL = id === getCardIdInURL;

  return (findBlogInURL && findCardIdInURL && isCardIdSameAsIdInURL)
    ? (<h1 data-test="headline" className={styles.cardTitle}>{primaryHed}</h1>)
    : (<h2 data-test="headline" className={styles.cardTitle}>{primaryHed}</h2>);
};

CardHeadline.defaultProps = {
  primaryHed: '',
  path: '',
  id: '',
};

CardHeadline.propTypes = {
  primaryHed: PropTypes.string,
  path: PropTypes.string,
  id: PropTypes.string,
};

export default CardHeadline;
